  <p class="title">
    Disbursement

    <mat-icon class="titleIcon">chevron_right</mat-icon> Final DA
  </p>
<div class="main-container" [ngClass]="{ 'theme-dark': isDarkMode() }">
    <div class="dashboard-wrapper">
        <div class="dashboard-container">
            <!-- Left Section -->
            <div class="form-section custom-border">
                <form *ngIf="fdaCreateForm" [formGroup]="fdaCreateForm">
                    <div class="section-disbursement">
                        <!-- Checkbox -->
                        <mat-checkbox formControlName="fdaFromPDA" class="checkbox-text">
                            Do you want to create FDA from PDA for a selected Disbursement
                        </mat-checkbox>

                        <!-- Dropdown -->
                        <mat-form-field appearance="outline" class="full-width">
                            <mat-label>Select Disbursement ID</mat-label>
                            <input type="text" matInput formControlName="disbursementId" [matAutocomplete]="auto"
                                placeholder="Enter Disbursement ID" (click)="trigger.openPanel()"
                                #trigger="matAutocompleteTrigger" required (blur)="onRemove('disbursementId')">

                            <mat-autocomplete #auto="matAutocomplete"
                                (optionSelected)="onDisbursementSelected($event.option.value)">
                                <mat-option *ngFor="let dis of filteredDisbursementId" [value]="dis">
                                    {{ dis }}
                                </mat-option>
                            </mat-autocomplete>

                            <mat-error *ngIf="fdaCreateForm.get('disbursementId')?.hasError('required')">
                                Disbursement is required
                            </mat-error>
                        </mat-form-field>

                    </div>

                    <div class="field-grid">
                        <div *ngFor="let field of fields; let i = index">
                            <!-- Select field -->
                            <mat-form-field *ngIf="field.type === 'select'" appearance="outline">
                                <mat-label>{{ field.name }}</mat-label>

                                <!-- Input bound to formControl -->
                                <input type="text" matInput [formControlName]="field?.value" [matAutocomplete]="auto"
                                    placeholder="Enter {{ field.name }}" (click)="trigger.openPanel()"
                                    #trigger="matAutocompleteTrigger" (blur)="onRemove(field)" />

                                <mat-autocomplete #auto="matAutocomplete"
                                    (optionSelected)="onSelect(field.name, $event.option)"
                                    [displayWith]="displayFn.bind(this, field)">
                                    <mat-option *ngFor="let opt of getFilteredOptions(field)"
                                        [value]="getOptionValue(field, opt, addedFields)">
                                        {{ field.name === 'Cargo' ? opt?.type : (field.name === 'ToCurrency' ||
                                        field.name === 'FromCurrency') ? opt : opt?.name }}
                                    </mat-option>
                                </mat-autocomplete>

                                <!-- Error -->
                                <mat-error *ngIf="fdaCreateForm.get(field.value)?.hasError('required')">
                                    Please select the {{ field.name }}
                                </mat-error>
                            </mat-form-field>

                            <!-- Date field -->
                            <!-- <app-date-time-picker *ngIf="field.type === 'date'" [form]="portAgentForm"
                        [fieldValue]="field.value" [label]="field.name">
                        </app-date-time-picker> -->

                            <mat-form-field appearance="outline" *ngIf="field.type === 'date'">
                                <mat-label>{{ field.name }}</mat-label>
                                <input matInput [matDatepicker]="picker" [formControlName]="field.value"
                                    placeholder="Enter {{ field.name }}" (dateChange)="onDateChange()" />
                                <!-- Datepicker -->
                                <mat-datepicker-toggle matIconSuffix [for]="picker">
                                </mat-datepicker-toggle>
                                <mat-datepicker #picker></mat-datepicker>
                                <mat-error *ngIf="fdaCreateForm.get(field.value)?.hasError('required')">
                                    please select the {{ field.name }}
                                </mat-error>
                            </mat-form-field>

                            <mat-form-field *ngIf="field.type !== 'date' && field.type !== 'select'"
                                appearance="outline">
                                <mat-label>{{ field.name }}</mat-label>
                                <input matInput [type]="field.data_type || 'text'" [formControlName]="field.value"
                                    placeholder="Enter {{ field.name }}" [readonly]="field.pdareadOnly" />

                                <mat-error *ngIf="fdaCreateForm.get(field.value)?.hasError('required')">
                                    {{ field.name }} is required
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                </form>
                <div class="calculate-container" *ngIf="!fdaCreateForm.get('fdaFromPDA')?.value">
                    <button (click)="onCalculate()" class="cal-btn">Calculate</button>
                </div>
            </div>

            <!-- Right Section -->
            <div class="form-section custom-border">
                <h1 class="section-title">Service Charges</h1>

                <div class="service-section">
                    <div class="table-container">
                        <table mat-table [dataSource]="datasource" class="mat-elevation-z1" [ngClass]="{ 'dark-table': isDarkMode() }">
                            <ng-container matColumnDef="Sl.No">
                                <th mat-header-cell *matHeaderCellDef style="width: 30px;"> Sl.No </th>
                                <td mat-cell *matCellDef="let row; let i = index">
                                    <ng-container *ngIf="!row.get('isSubService')?.value">
                                        <span>{{ getMainServiceIndex(i, datasource) }}</span>
                                    </ng-container>

                                </td>
                                <td mat-footer-cell *matFooterCellDef></td>
                            </ng-container>
                            <!-- Normal columns -->
                            <!-- Service column -->
                            <ng-container matColumnDef="service">
                                <th mat-header-cell *matHeaderCellDef style="width: 180px;"> Service </th>
                                <td mat-cell *matCellDef="let element" class="align-left">
                                    <!-- MAIN SERVICE -->
                                    <ng-container *ngIf="!element.get('isSubService')?.value">
                                        {{ element.get('service')?.value }}
                                    </ng-container>

                                    <!-- SUBSERVICE -->
                                    <ng-container *ngIf="element.get('isSubService')?.value">
                                        {{ element.get('name')?.value }}
                                    </ng-container>
                                </td>
                                <td mat-footer-cell *matFooterCellDef class="total-agent-value">
                                    <strong>Total</strong>
                                </td>
                            </ng-container>

                            <!-- Formula column -->
                            <ng-container matColumnDef="formula">
                                <th mat-header-cell *matHeaderCellDef style="width: 170px;"> Formula</th>
                                <td mat-cell *matCellDef="let row" class="align-right">
                                    {{ row.get('formula_result')?.value }} <br> <br> {{ row.get('formula_inputs')?.value
                                    }}
                                </td>
                                <td mat-footer-cell *matFooterCellDef></td>
                            </ng-container>

                            <!-- Value column -->
                            <ng-container matColumnDef="value">
                                <th mat-header-cell *matHeaderCellDef style="width: 170px;"> Value</th>
                                <td mat-cell *matCellDef="let row" class="align-right">
                                    {{ row.get('isSubService')?.value ? row.get('sub_total')?.value :
                                    row.get('total')?.value }}
                                </td>
                                <td mat-footer-cell *matFooterCellDef class="total-agent-value">
                                    {{ merakiGrandTotal }}
                                </td>
                            </ng-container>

                            <!-- Header -->
                            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                            <!-- Row definition -->
                            <tr mat-row *matRowDef="let row; columns: displayedColumns"
                                [ngClass]="{ 'subservice-row': row.get('isSubService')?.value }"
                                [hidden]="row.get('isSubService')?.value && (row.get('optional')?.value === 'Y')">
                            </tr>
                            <!-- Footer -->
                            <tr mat-footer-row *matFooterRowDef="displayedColumns; sticky: true" class="footer-row">
                            </tr>

                        </table>
                    </div>

                </div>
            </div>

        </div>
    </div>

    <div class="submit-container">
        <button (click)="onSubmit()" class="sub-btn" [disabled]="disableSubmitButton"
            [class.btn-disabled]="disableSubmitButton">
            Submit
        </button>
    </div>
</div>